export default __webpack_public_path__ + "static/media/resume.8fc40602.pdf";